/**
 * @fileoverview Zod schema for Sales Pipeline's "Assign Owner" form.
 * @description One required field, the Sales Executive to make the prospect's owner. The message is
 * a translation key, translated only at the display call site in AssignOwnerDialog.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { z } from 'zod'

/** @description The assign-owner form's rules. */
export const assignOwnerFormSchema = z.object({
  ownerUserId: z.string().trim().min(1, 'sales.pipeline.assignOwner.errors.ownerRequired'),
})

/** @description The assign-owner form's values. */
export type AssignOwnerFormValues = z.infer<typeof assignOwnerFormSchema>
